import { Col, Row } from "react-grid-system";
import { ChangePassword } from "../ChangePassword";

export const AccountSettings = () => {
	return (
		<>
			<Row>
				<Col>
					<h1>Account settings</h1>
				</Col>
			</Row>
			<Row>
				<Col>
					<ChangePassword />
				</Col>
			</Row>
		</>
	);
};
